import Auth from "./Auth";
import Bar from "./Bar";
import CakeRoom from "./CakeRoom";
import TableOrder from "./Components/TableOrder";
import Dashboard from "./Dashboard";
import Kitchen from "./Kitchen";
import POS from "./POS";
import Waiter from "./Waiter";

export default {
  Auth,
  POS,
  Kitchen,
  Waiter,
  Dashboard,
  Bar,
  TableOrder,
  CakeRoom,
};
